// @vue/component
import { hToggleArrayItem, hDeepCopy } from '@/utils/helpers';
import ShCard from '@/components/Helpers/ShCard';
import ShUserAvatar from '@/components/Helpers/ShUserAvatar';
import ShStarRating from '@/components/Helpers/ShStarRating';
import ShButton from '@/components/Helpers/ShButton';
import MultipleSelect from '@/components/Common/MultipleSelect';
import MultipleAdd from '@/components/Common/MultipleAdd';
import DepartmentSign from '@/components/Common/DepartmentSign';
import ConnectionsUtilsPagination from '@/components/Connections/ConnectionsUtilsPagination';

// @vue/component
export default {
  name: 'ConnectionsListFilterAndSearch',
  components: {
    ShCard,
    ShUserAvatar,
    ShStarRating,
    ShButton,
    MultipleSelect,
    MultipleAdd,
    DepartmentSign,
    ConnectionsUtilsPagination,
  },

  props: {
    connectionsFilters: {
      type: Object,
      default() {
        return {
          calling_number: [],
          widgets_id_fk: [],
          date: [],
          agent_id: [],
          department_id: [],
          session_id: [],
          notify_status: [],
          effect: [],
          direction: [],
          menu: [],
        };
      },
    },
  },

  data() {
    return {
      isAdvancedDataVisible: false,
      dateRange: null,
      editableConnectionsFilters: null,
    };
  },

  computed: {
    isLoading() {
      return this.$store.getters['app/pendingStoreActions'].includes(['connections/getConnections']);
    },
    connectionsSettings() {
      return this.$store.getters['connections/connectionsSettings'];
    },
    agentsList() {
      return this.$store.getters['agents/list'];
    },
    widgetsList() {
      return this.$store.getters['widgets/list'];
    },
    departmentsList() {
      return this.$store.getters['departments/list'];
    },
    ivrMenu() {
      return this.$store.getters['ivr/ivrMenu'];
    },
    dictionaryBillingEffect() {
      return this.$store.getters['app/dictionaryBillingEffect'];
    },
    dictionaryBillingDirection() {
      return this.$store.getters['app/dictionaryBillingDirection'];
    },
    feedbackRatings() {
      return [{ value: 5 }, { value: 4 }, { value: 3 }, { value: 2 }, { value: 1 }];
    },
  },

  watch: {
    connectionsFilters: {
      handler(newFilters) {
        this.editableConnectionsFilters = hDeepCopy(newFilters);
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    __setConnectionsDownloadParams() {
      this.$EventBus.$emit('ConnectionsUtilsPagination/SYNC_PAGE_NUMBER', 1);
      this.$store.dispatch('connections/setConnectionsDownloadParams', { filters: this.editableConnectionsFilters, page: 1 });
    },
    handleSelect({ selectedItem, name }) {
      this.editableConnectionsFilters[name] = hToggleArrayItem(this.editableConnectionsFilters[name], selectedItem);
      this.__setConnectionsDownloadParams();
    },
    handleClear({ name }) {
      this.editableConnectionsFilters[name] = [];
      this.__setConnectionsDownloadParams();
    },
    handleClearDate() {
      this.dateRange = null;
      this.handleClear({ name: 'date' });
    },
    handleAdd({ newItem, name }) {
      this.editableConnectionsFilters[name].push(newItem);
      this.__setConnectionsDownloadParams();
    },
    handleRemoveItem({ item, name }) {
      const itemIndex = this.editableConnectionsFilters[name].indexOf(item);
      this.editableConnectionsFilters[name].splice(itemIndex, 1);
      this.__setConnectionsDownloadParams();
    },
    handleDateRangeChange() {
      this.editableConnectionsFilters.date = this.dateRange.some(date => date === null) ? [] : this.dateRange;
      this.__setConnectionsDownloadParams();
    },
    clearConnetionsDownloadFilter() {
      this.dateRange = null;
      this.$store.dispatch('connections/clearConnetionsDownloadFilter');
    },
  },

};
